import { RightSection } from "./components/rightSection/RightSection";
import { Main } from "./components/main/Main";
import { BlueBanner } from "./components/main/BlueBanner";
import { ContentWrapper727 } from "../../components/contentWrappers/ContentWrapper727";
import { InfoSection } from "./components/main/InfoSection";

export const HomePage = () => {
  return (
    <div className="flex flex-col md:flex-row">
      <div className="flex flex-col flex-grow md:px-8 pb-8 ">
        <ContentWrapper727>
          <div className="mb-4">
            <BlueBanner />
          </div>
          <div className="mb-4">
            <Main />
          </div>
          <div className="mb-8">
            <InfoSection />
          </div>

          {/* Right Section for Mobile */}
          <div className="block md:hidden">
            <RightSection />
          </div>
        </ContentWrapper727>
      </div>

      {/* Right Section for Larger Screens */}
      <div className="hidden md:block w-[348px] h-screen md:right-8 md:top-16">
        <RightSection />
      </div>
    </div>
  );
};
